import React from "react"

import classNames from "classnames"

import { IconSize } from "shared/types/Icon"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"
import { Link } from "shared/ui/link/Link"
import { Skeleton } from "shared/ui/skeleton/Skeleton"

export interface BreadcrumbItemProps {
  title?: string
  isActive?: boolean
  onClick?: () => void
  isLoading?: boolean
}

export const BreadcrumbItem = React.memo(
  ({ title, isActive, isLoading, onClick }: BreadcrumbItemProps) => (
    <li
      className={classNames("breadcrumb-item", isActive ? "active" : undefined)}
      aria-current={isActive ? "page" : undefined}
      data-testid="breadcrumb-item"
    >
      {isLoading ? <Skeleton /> : <Link onClick={onClick}>{title}</Link>}
      <Icon
        className="breadcrumb-item__separator"
        name={IconName.SMALL_CARET_RIGHT}
        size={IconSize.XXS}
      />
    </li>
  )
)
